import {
  ON_CONSIGNMENT_TYPE_CHANGE,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  SHOW_MESSAGE,
  CONSIGNMENTS_DATA,
  CONSIGNMENT_POST_DATA,
  CONSIGNMENT_POST_DATA_ERROR,
  ON_DENOMINATION_ADD,
  ON_VIEWSINGLE_CONSIGNMENT
} from './../constants/ActionTypes';
import axios from 'util/ConsignmentsApi';
import { getUserDetails } from './Auth';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
//import { async } from 'validate.js';


export const changeConsignmentType = (consType) => {
  return (dispatch) => {
    dispatch({ type: ON_CONSIGNMENT_TYPE_CHANGE, payload: consType });
  }
}

export const setDenominationPostData = (denomination) => {
  return (dispatch) => {
    dispatch({ type: ON_DENOMINATION_ADD, payload: denomination });
  }
}

export const postConsignment = (tran_type, postData) => (dispatch) => {
  // Perform asynchronous operation (e.g., API call)

  postData.created_by = getUserDetails().ID;
  delete postData.openResp;
  delete postData.openRespStatus;
  delete postData.openRespMessage;
  

  let newAmount = String(postData.amount).replace(/\s/g, "");
  //delete postData.amount;
  postData.amount = parseInt(newAmount);


  let token = sessionStorage.getItem('token');
  
  const _data = {
    params: null,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }

  axios.post('consignment/' + tran_type, [postData], _data)
    .then((resp) => {
      //alert(JSON.stringify(resp))
      dispatch({ type: CONSIGNMENT_POST_DATA, payload: postData }); // Just to keep memory of the recently added
      dispatch({ type: FETCH_START });
      if (resp && resp["data"] == 201) {
        //dispatch({type: FETCH_SUCCESS});
        sessionStorage.setItem('isSuccess', 'true')
        //dispatch({ type: SHOW_MESSAGE, payload: "Consignment Requested Successfully" });
        dispatch({ type: CONSIGNMENT_POST_DATA, payload: "Consignment Requested Successfully" });
      }else if (resp && resp["data"] == 203) {
        //dispatch({type: FETCH_SUCCESS});
        //alert("Center balance limit violated")
        //sessionStorage.setItem('isSuccess', 'false')
        //sessionStorage.setItem('errorMessage', 'Center balance limit violated');
        //dispatch({type: FETCH_ERROR, payload: "Center balance limit violated"});
        dispatch({type: CONSIGNMENT_POST_DATA_ERROR, payload: "Center balance limit violated"});
      } else {
        //alert("Failed to Request Consignment")
        //sessionStorage.setItem('errorMessage', 'Failed to Request Consignment')
        //dispatch({type: FETCH_ERROR, payload: "Failed to Request Consignment"});
        dispatch({type: CONSIGNMENT_POST_DATA_ERROR, payload: "Failed to Request Consignment"});
      }
      
    })
    .catch((error) => {
      // Dispatch an error action if needed
      //console.log('error error', error.message)
      dispatch({ type: CONSIGNMENT_POST_DATA_ERROR, payload: "Failed to Request Consignment" });
      
      //sessionStorage.setItem('isSuccess', 'false')
      //console.log("Error****:", error);
      //alert('On Error part');
      //alert('On Error part '+JSON.stringify(error))
      if (error) {
        // alert('Failed to Request Consignment with Error '+error);
        sessionStorage.setItem('isSuccess', 'false')
      } else {
        //alert('Consignment Request Updated Successfully');
        sessionStorage.setItem('isSuccess', 'true')
      }

    });
};

export const getConsignmentByType = (searchOptions) => {
  // alert(searchOptions);

  // alert('Inaenda')

  //alert(JSON.stringify(searchOptions))

  let consType = (searchOptions.type) ? searchOptions.type : null;
  // let status = (searchOptions.status)? searchOptions.status:null;
  // let action_date = (searchOptions.action_date)? searchOptions.action_date: null;

  let searchOptionsStr = 'BANK_CODE=' + searchOptions.BANK_CODE + '&BRANCH_CODE=' + searchOptions.BRANCH_CODE;
  if (searchOptions.status) {
    searchOptionsStr += '&status=' + searchOptions.status;
  }
  if (searchOptions.action_date && searchOptions.action_date !== 'all') {
    searchOptionsStr += '&action_date=' + searchOptions.action_date
  }
  if (searchOptions.ACTION_DATE2 && searchOptions.ACTION_DATE2 !== 'all') {
    searchOptionsStr += '&ACTION_DATE2=' + searchOptions.ACTION_DATE2
  }
  if (searchOptions.ACTION_DATE && searchOptions.ACTION_DATE !== 'all') {
    searchOptionsStr += '&ACTION_DATE=' + searchOptions.ACTION_DATE
  }
  if (searchOptions.CUSTODY_CENTER_ID && searchOptions.CUSTODY_CENTER_ID > 0) {
    searchOptionsStr += '&CUSTODY_CENTER_ID=' + searchOptions.CUSTODY_CENTER_ID
  }

  let token = sessionStorage.getItem('token');

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };

  return (dispatch) => {
    dispatch({ type: FETCH_START });
    axios.get('consignment/' + consType + '?' + searchOptionsStr, _data,
    ).then(({ data }) => {
      //alert('Imeenda')
      //console.log('Success');
      //console.log("Fetched Consignments: ", data);
      if (data.length) {
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: CONSIGNMENTS_DATA, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch(function (error) {
      //alert('Imegoma'+JSON.stringify(error))
      //console.log('Not executing this one', error); 
      dispatch({ type: FETCH_ERROR, payload: error.message });
      //console.log("Error****:", error.message);
    });
  }
}

///consignment/{consignmentType}/reconciliation

export const postToReconcileBalance = (payload) => (dispatch) => {
  // Perform asynchronous operation (e.g., API call)
  let token = sessionStorage.getItem('token');  
  const _data = {
    params: null,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }

  let tran_type = 3;
  axios.post('consignment/' + tran_type + '/reconciliation', payload, _data)
    .then((resp) => {
      dispatch({ type: FETCH_START });
      dispatch({ type: CONSIGNMENT_POST_DATA, payload: payload }); // Just to keep memory of the recently added
      //alert((resp["data"]["statusCode"]))
      //console.log('resp resp',resp["data"])
      //alert((JSON.stringify(resp)))
      if (resp["data"]["code"] == 202) {
        alert("Balance reconciled Successfully")
        dispatch({ type: SHOW_MESSAGE, payload: "Balance reconciled Successfully" });
        window.location.replace(window.location.origin+"/app/reports")
        
      } else if (resp["data"]["code"] == 400) {
        alert(JSON.stringify(resp["data"]["message"]))
        dispatch({ type: FETCH_ERROR, payload: resp["data"]["message"] });
      } else {
        alert("Balance Failed to Reconcile")
        dispatch({ type: FETCH_ERROR, payload: "Balance Failed to Reconcile" });
      }
      
    })
    .catch((error) => {
      // Dispatch an error action if needed
      //console.log('error error', error.message)
      //alert(JSON.stringify(error))
      // alert('Error '+error.message)
      // dispatch({ type: FETCH_ERROR, payload: "Failed to Resend Consignment" });
      dispatch({ type: FETCH_ERROR, payload: error.message });

    });
};

export const postToReconcileBalancePrev = async (payload) => {
  let token = sessionStorage.getItem('token');  
  const _data = {
    params: null,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }

  let tran_type = 3;

  return  async (dispatch) => {
    dispatch({ type: CONSIGNMENT_POST_DATA, payload: payload }); // Just to keep memory of the recently added
    dispatch({ type: FETCH_START });
    await axios.post('consignment/' + tran_type + '/reconciliation', payload, _data
    ).then((resp) => {
      alert(resp["data"]["statuscode"])
      //console.log('resp resp',resp["data"])
      if (resp["data"]["statuscode"] >= 200 && resp["data"]["statusCode"] <= 202) {
        dispatch({ type: SHOW_MESSAGE, payload: "Consignment Resent Successfully" });
      } else if (resp["data"]["statuscode"] == 400) {
        dispatch({ type: FETCH_ERROR, payload: resp["data"]["message"] });
      } else {
        dispatch({ type: FETCH_ERROR, payload: "Consignment Failed to Resend" });
      }


    }).catch((error) => {
      //console.log('error error', error.message)
      alert(JSON.stringify(error))
      // alert('Error '+error.message)
      // dispatch({ type: FETCH_ERROR, payload: "Failed to Resend Consignment" });
      dispatch({ type: FETCH_ERROR, payload: error.message });

    });
  }

}

export const postPendingConsignment = (payload) => (dispatch) => {
  // Perform asynchronous operation (e.g., API call)
  let token = sessionStorage.getItem('token');  
  const _data = {
    params: null,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }

  let tran_type = 3;
  axios.post('consignment/' + tran_type + '/pending', [payload], _data)
    .then((resp) => {
      dispatch({ type: FETCH_START });
      dispatch({ type: CONSIGNMENT_POST_DATA, payload: payload }); // Just to keep memory of the recently added
      //alert((JSON.stringify(resp)))
      //console.log('resp resp',resp["data"])
      if (resp["data"]["statuscode"] == 202 || resp["data"]["statuscode"] == 200) {
        //alert("Consignment Resent Successfully")
        dispatch({ type: SHOW_MESSAGE, payload: "Consignment Resent Successfully" });
        window.location.replace(window.location.origin+"/app/reports")
        
      } else if (resp["data"]["statuscode"] == 400) {
        //alert(JSON.stringify(resp["data"]["message"]))
        dispatch({ type: FETCH_ERROR, payload: resp["data"]["message"] });
      } else {
        alert("Balance Failed to Resend")
        dispatch({ type: FETCH_ERROR, payload: "Balance Failed to Resend" });
      }
      
    })
    .catch((error) => {
      // Dispatch an error action if needed
      console.log('error error', error.message)
      //alert(JSON.stringify(error))
      // alert('Error '+error.message)
      // dispatch({ type: FETCH_ERROR, payload: "Failed to Resend Consignment" });
      dispatch({ type: FETCH_ERROR, payload: error.message });

    });
};

export const postPendingConsignmentPrev = async (consignmentData) => {
  //alert(JSON.stringify(consignmentData))
  let token = sessionStorage.getItem('token');
  //    const _data = {
  //    headers: {
  //        Authorization: `Bearer ${token}`,
  //    }
  // };

  const _data = {
    params: null,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }

  let tran_type = 3;

  return  async (dispatch) => {
    dispatch({ type: CONSIGNMENT_POST_DATA, payload: consignmentData }); // Just to keep memory of the recently added
    dispatch({ type: FETCH_START });
    await axios.post('consignment/' + tran_type + '/pending', [consignmentData], _data
    ).then((resp) => {
      //console.log('resp resp',resp["data"])
      if (resp["data"]["statuscode"] >= 200 && resp["data"]["statuscode"] <= 202) {
        dispatch({ type: SHOW_MESSAGE, payload: "Consignment Resent Successfully" });
      } else if (resp["data"]["statuscode"] == 400) {
        dispatch({ type: FETCH_ERROR, payload: resp["data"]["message"] });
      } else {
        dispatch({ type: FETCH_ERROR, payload: "Consignment Failed to Resend" });
      }


    }).catch((error) => {
      //console.log('error error', error.message)
      // alert('Error '+error.message)
      // dispatch({ type: FETCH_ERROR, payload: "Failed to Resend Consignment" });
      dispatch({ type: FETCH_ERROR, payload: error.message });

    });
  }

}

export const getPendingConsignment = () => {
  let token = sessionStorage.getItem('token');
  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };
  let consType = 3;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    axios.get('consignment/' + consType + '/pending', _data,
    ).then(({ data }) => {
      //alert('Imeenda')
      //console.log('Success');
      //console.log("Fetched Consignments: ", data);
      if (data.length) {
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: CONSIGNMENTS_DATA, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch(function (error) {
      //alert('Imegoma'+JSON.stringify(error))
      //console.log('Not executing this one', error); 
      dispatch({ type: FETCH_ERROR, payload: error.message });
      //console.log("Error****:", error.message);
    });
  }
}

export const getConsignmentById = (consType = 1, consId = 33) => { // update this with the appropriate variables
  let token = sessionStorage.getItem('token');

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };

  return (dispatch) => {
    dispatch({ type: FETCH_START });
    axios.get('consignment/' + consType + '/' + consId, _data,
    ).then(({ data }) => {
      // console.log('Success >>>>',data);
      //console.log("Fetched Consignments Details: ", Object.keys(data).length);
      if (Object.keys(data).length) {
        //console.log('In the data route');
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: ON_VIEWSINGLE_CONSIGNMENT, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch(function (error) {
      //console.log('Execution Error ', error); 
      dispatch({ type: FETCH_ERROR, payload: error.message });
      //console.log("Error****:", error.message);
    });
  }
}

export const UpdateConsignment = (consType, consId, consData) => { // update this with the appropriate variables

  let newObject = { ...consData[0] };
  //console.log('consData update',newObject)

  delete newObject.custodian1_at_source_name;
  delete newObject.custodian1_at_source_pic;
  delete newObject.custodian2_at_source_name;
  delete newObject.custodian2_at_source_pic;
  delete newObject.escorter1_name;
  delete newObject.escorter1_pic;
  delete newObject.escorter2_name;
  delete newObject.escorter2_pic;
  delete newObject.custodian1_at_destination_name;
  delete newObject.custodian1_at_destination_pic;
  delete newObject.custodian2_at_destination_name;
  delete newObject.custodian2_at_destination_pic;
  delete newObject.created_by_name;
  delete newObject.authorizer_name;
  delete newObject.authorizer_pic;
  delete newObject.updated_by;
  delete newObject.scc_name;
  //delete consData.scc_name;
  delete newObject.denominatoinDetails;
  //delete consData.denominatoinDetails;
  delete newObject.custodian2_at_destination_sig;
  delete newObject.escorter2_sig;
  delete newObject.authorizer_sig;
  delete newObject.escorter1_sig;
  delete newObject.custodian1_at_source_sig;
  delete newObject.custodian2_at_source_sig;
  delete newObject.custodian1_at_destination_sig;
  delete newObject.created_by_pic;
  delete newObject.created_by_sig;
  delete newObject.attachment_ref;

    
 

  
  // console.log('consData update 2',newObject)

  //delete consData[0].denomination;
  //alert('To Update '+JSON.stringify(consData))

  if (newObject.denomination && newObject.denomination.length > 0) {
    for (let index = 0; index < newObject.denomination.length; index++) {
      delete newObject.denomination[index].year;
      delete newObject.denomination[index].packaging;
    }
  }
  //alert(consData[0].denomination)
  //alert(JSON.stringify(consData[0]))


  newObject.updated_at = new Date();

  let token = sessionStorage.getItem('token');

  // alert(JSON.stringify(consData))
  //console.log('consData',consData)

  // const _data = {
  //    headers: {
  //        Authorization: `Bearer ${token}`,
  //    }
  // };

  var _data = {
    headers: {
      // 'Content-Type': 'application/json',
      // 'Accept': 'application/json',
      // 'sender': 'FVS',
      // 'consumer': 'CBS',
      // 'payload_type': 'JSON',
      'Authorization': 'Bearer ' + token
    }
    // data: {}
  };
  return async (dispatch) => {
    dispatch({ type: FETCH_START });
    await axios.put('consignment/' + consType + '/' + consId, [newObject], _data
    ).then(({ data }) => {
      //console.log('Successssssssssssssss',data);
      //alert(JSON.stringify(data))
      //console.log("Successfully Updated the consignment: ", Object.keys(data).length);
      //console.log("Successfully Updated the consignment: ");


      if (data == 201) {
        // dispatch({type: FETCH_SUCCESS});
        dispatch({ type: SHOW_MESSAGE, payload: "Consignment Updated Successfully" });
        sessionStorage.setItem('isSuccess', 'true')
        window.location.reload()
      }else if (data == 400) {
        // dispatch({type: FETCH_SUCCESS});
        sessionStorage.setItem('isSuccess', 'false')
        sessionStorage.setItem('errorMessage', 'Center balance limit is violated')
        dispatch({ type: SHOW_MESSAGE, payload: "Center balance limit is violated" });
      } else {
        sessionStorage.setItem('isSuccess', 'false')
        sessionStorage.setItem('errorMessage', 'Please ensure denomination balance is available')
        //alert('Failed to Update Consignment Request');
        dispatch({ type: FETCH_ERROR, payload: 'Failed to update consignment, check denominations' });
      }
      //alert('Consignment Request Updated Successfully');
      // if (Object.keys(data).length) { 
      //   dispatch({type: FETCH_SUCCESS});
      //   console.log('successfully updated');
      //   alert('successfully updated');
      //   // format data and store them for use..
      //   // dispatch({type: ON_VIEWSINGLE_CONSIGNMENT, payload: data});
      // } else {
      //   dispatch({type: FETCH_ERROR, payload: data.error});
      // }
    }).catch(function (error) {
      //alert(JSON.stringify(error))
      //console.log('Execution Error ', error); 
      sessionStorage.setItem('isSuccess', 'false')
      sessionStorage.setItem('errorMessage', 'Request Failed')
      //alert('Failed to Update Consignment Request');
      // dispatch({type: FETCH_ERROR, payload: error.message});
      dispatch({ type: FETCH_ERROR, payload: 'Failed to update consignment' });
      //console.log("Error****:", error.message);
    });
  }
}